import RoamingBanner from 'components/RoamingBanner';
import RoamingMainForm from 'components/RoamingMainForm';
import RoamingNetworkInfo from 'components/RoamingNetworkInfo';
import RoamingProducts from 'components/RoamingProducts';
import RoamingProductEU from 'components/RoamingProductEU';
import { useRoamingPage } from './useRoamingPage';

const RoamingPage = () => {
  const {
    countries,
    countriesFlags,
    countriesBanners,
    roamingBannerData,
    selectedCountry,
    providersInfo,
    chargesInfo,
    networkInfo,
    isEuZone,
    productsInfo,
    euProductInfo,
    isSatelliteZone,
    onFormSubmit,
  } = useRoamingPage();

  return (
    <>
      <RoamingMainForm
        countries={countries}
        flags={countriesFlags}
        banners={countriesBanners}
        selectedCountry={selectedCountry}
        onSubmit={onFormSubmit}
      />
      {isSatelliteZone ? undefined : isEuZone ? (
        euProductInfo && <RoamingProductEU euProductInfo={euProductInfo} />
      ) : (
        <RoamingProducts productsInfo={productsInfo} isCountrySelected={!!selectedCountry} />
      )}
      {chargesInfo && networkInfo && providersInfo && (
        <RoamingNetworkInfo networkInfo={networkInfo} providersInfo={providersInfo} chargesInfo={chargesInfo} />
      )}
      {roamingBannerData && <RoamingBanner roamingBannerData={roamingBannerData} />}
    </>
  );
};

export default RoamingPage;
